import { render } from "./Pdfvuer.vue?vue&type=template&id=43f7df1d"
import script from "./Pdfvuer.vue?vue&type=script&lang=js"
export * from "./Pdfvuer.vue?vue&type=script&lang=js"

import "pdfjs-dist/web/pdf_viewer.css?vue&type=style&index=0&lang=css"
script.render = render

export default script